export * from '@containers/DetailsPages/pages/EventDetails/components/RestrictionsInfo/restrictionsInfo';
